module.exports = __webpack_public_path__ + "img/calender_icon.01bb150.png";